import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, memo, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const SubscriptionAireBornMenuComponent = ({
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: Props): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Iscrizione AIRE per trascrizione atto di nascita" />
      </ListItem>
      <Menu
        id="subscription-aire-born-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        <MenuItem
          key="solo-menu-item-born"
          onClick={(event) => {
            onClose(event);
            navigate('/iscrizioni/aire-nascita-solo');
          }}
        >
          <Typography variant="inherit">Solo</Typography>
        </MenuItem>
        <Divider key="solo-born-divider" />
        <MenuItem
          key="aggregazione-menu-item-born"
          onClick={(event) => {
            onClose(event);
            navigate('/iscrizioni/aire-nascita-aggregazione');
          }}
        >
          <Typography variant="inherit">Aggregazione a famiglia</Typography>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

SubscriptionAireBornMenuComponent.displayName = 'Subscription Aire Born Menu';

const SubscriptionAireBornMenu = memo(SubscriptionAireBornMenuComponent);

export default SubscriptionAireBornMenu;
